import React, { Component } from 'react';
import styled from '@emotion/styled';
import { DIVIDER_COLORS } from 'Style/colors';
import { SPACING } from 'Style/spacing';

import connector from 'Utils/connector';
import connectAmp, {
  ConnectAmpProps,
} from 'Webapp/shared/app/connectors/connectAmp';
import connectFeatureFlags, {
  ConnectFeatureFlagsProps,
} from 'Webapp/shared/app/connectors/connectFeatureFlags';
import connectAdTargeting, {
  ConnectAdTargetingProps,
} from 'Webapp/shared/app/connectors/connectAdTargeting';

import AdSlot from './ad-slot';
import {
  AD_UNIT_PATHS,
  MEDIUM_RECTANGLE_SIZES,
  isInfeedAdEnabled,
} from './ads-config';
import { setPageTargeting } from './gpt';

// Match the story-card tile container (see StyledListItem in
// Webapp/shared/app/components/item.tsx) so the ad card sits consistently in
// the 3-wide story grids.
const StyledAdCard = styled.div({
  border: `2px solid ${DIVIDER_COLORS.primary}`,
  borderRadius: SPACING.MEDIUM,
  overflow: 'hidden',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: `${SPACING.LARGE} 0`,
});

type InfeedAdCardProps = ConnectAmpProps &
  ConnectFeatureFlagsProps &
  ConnectAdTargetingProps;

/**
 * Ad card inserted into section story grids as an EXTRA tile (never replacing
 * content) — see the injection in views/section/item-list.tsx. 300x250,
 * lazily loaded, centered in a story-card-styled container.
 */
class InfeedAdCard extends Component<InfeedAdCardProps> {
  componentDidMount() {
    this.applyPageTargeting();
  }

  shouldRender = () => {
    const { isAmp, featureFlags } = this.props;
    return !isAmp && isInfeedAdEnabled(featureFlags);
  };

  applyPageTargeting = () => {
    if (!this.shouldRender()) {
      return;
    }
    const { adPageType, adTopicSlug } = this.props;
    setPageTargeting({
      page_type: adPageType,
      topic_slug: adTopicSlug,
    });
  };

  render() {
    if (!this.shouldRender()) {
      return null;
    }
    const { adPageType, adTopicSlug } = this.props;
    const targeting: Record<string, string> = {};
    if (adPageType) {
      targeting.page_type = adPageType;
    }
    if (adTopicSlug) {
      targeting.topic_slug = adTopicSlug;
    }
    return (
      <StyledAdCard className="infeed-ad-card">
        <AdSlot
          name="infeed"
          placementFlag="WEB_ADS_INFEED"
          adUnitPath={AD_UNIT_PATHS.infeed}
          sizes={MEDIUM_RECTANGLE_SIZES}
          // The in-feed card sits in the story grid styled like a story
          // tile — FTC/IAB native-ad disclosure applies, unlike the
          // visually-distinct banner slots.
          showLabel
          lazy
          targeting={targeting}
        />
      </StyledAdCard>
    );
  }
}

export default connector<InfeedAdCardProps>(
  connectAmp,
  connectFeatureFlags,
  connectAdTargeting,
)(InfeedAdCard);
